module.exports = __webpack_public_path__ + "img/resturants-cafes.dcab5c88.jpg";